import { guid } from '../util/helpers'

const fields = {
  basic: []
}

function seed () {
  const basic = [
    { name: 'Full name', type: 'text', value: '', readonly: 0 },
    { name: 'Job title', type: 'text', value: '', readonly: 0 },
    { name: 'Company', type: 'text', value: 'Educational Service Unit #2', readonly: 1 },
    { name: 'Website', type: 'text', value: 'www.esu2.org', readonly: 1 },
    { name: 'Email', type: 'email', value: '', readonly: 0 },
    { name: 'Phone', type: 'text', value: '+1 (402) 721-7710', readonly: 0 },
    { name: 'Zoom', type: 'text', value: '', readonly: 0 }
  ]

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() })
  })

  addPlaceholder()
}

function addPlaceholder () {
  const placeholders = [
    'Jane Doe',
    'Speech-Language Pathologist',
    'Educational Service Unit #2',
    'www.esu2.org',
    'mail@esu2.org',
    '+1 (123) 456-7890',
    'zoom.us/j/1234567890'
  ]

  fields.basicPlaceholder = [
    ...fields.basic.map((item, index) => {
      return { ...item, value: placeholders[index] }
    })
  ]
}

seed()

export default fields
